<mat-form-field class="w-full fuse-mat-no-subscript">
  <mat-select [ngModel]="value" (valueChange)="onSelection($event)">
    <mat-option>
      <ngx-mat-select-search placeholderLabel="Diagnóstico" [formControl]="filterCtrl">
        <div ngxMatSelectNoEntriesFound class="flex justify-between">
          <span> Nenhum registro corresponde à pesquisa. </span>
          <mat-progress-spinner *ngIf="loading$ | async" mode="indeterminate" [diameter]="32"
                                color="primary"></mat-progress-spinner>
        </div>
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let item of datasource$ | async" [value]="item.subCategoryId">
      {{ item.subCategoryId }} - {{ item.title }}
    </mat-option>
  </mat-select>
</mat-form-field>